import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import { SQLField, SQLInfo, SQLType } from '../framework.core/data/SQLInfo';
import { InvoDetail } from './InvoDetail';
import { ApDetail } from './ApDetail';
import { JobNames } from '../framework.core/JobNames';
import * as XCol from '../framework.core/XExportColumn';

export class OpAcct extends TrackableEntity {
    id: number = 0;
    tbName: string = '';
    tbId: number = 0;
    loc: number = 0;
    chgType: number = 0;
    billingCode: string = '';
    billingCodeView: string = '';
    description: string = '';
    entity: number = 0;
    cur1: string = '';
    rate: number = 0;
    qty: number = 0;
    actualAmt: number = 0;
    cur2: string = '';
    agentAmt: number = 0;
    useVat: boolean = false;
    ps: boolean = false;
    posted: string = '0';
    lActAmt: number = 0;
    lAgtAmt: number = 0;
    vatAmount: number = 0;
    actExrate: number = 0;
    agtExrate: number = 0;
    invoiced: boolean = false;
    settled: boolean = false;
    iDate: string | null = null;
    cDate: string | null = null;
    agent: number = 0;
    invoiceDate: string | null = null;
    crDbDate: string | null = null;
    dutyEntity: number = 0;
    dutyEntityName: string = '';
    dutyAgent: number = 0;
    dutyAgentName: string = '';
    blCur1: string = '';
    blCur2: string = '';
    billPaidAmt: number = 0;
    headCur: string = '';
    void: number = 0;
    invId: number = 0;
    seq: number = 0;
    cmdDesc: string = '';
    printDesc: string = '';
    locDesc: string = '';
    chgTypeDesc: string = '';
    entityName: string = '';
    actualAmtDesc: string = '';
    agentName: string = '';
    select: string = '0';
    selected: boolean = false;
    billDateDesc: string = '';
    invoiceNo: string = '';
    crDbNo: string = '';
    errorMsg: string = '';
    isChgTypeLock: boolean = false;
    isBillCodeLock: boolean = false;
    isDescLock: boolean = false;
    isEntityLock: boolean = false;
    isCur1Lock: boolean = false;
    isRateQtyLock: boolean = false;
    isAgentLock: boolean = false;
    isCur2Lock: boolean = false;
    isAgentAmtLock: boolean = false;
    isPsLock: boolean = false;
    isVatLock: boolean = false;
    isSelectLock: boolean = false;
    u1ID: string = '';
    u1Date: string|null = null;
    u2ID: string = '';
    u2Date: string|null = null;

    // cloud
    dirtyChgType: boolean = false;
    dirtyBillingCode: boolean = false;
    dirtyAgent: boolean = false;
    dirtyAgtCur: boolean = false;
    dirtyAgtAmount: boolean = false;
    cloudOnly: boolean = false;
    isDraft: boolean = false;
    billingCodeName: string = '';
    isDescOnly:boolean = false;

    print: boolean = false;

    constructor(init?:Partial<OpAcct>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'cmdDesc', 'printDesc', 'locDesc', 'chgTypeDesc', 'entityName', 'agentName', 'select', 'selected', 'billDateDesc', 'invoiceNo', 'crDbNo', 'errorMsg', 'isChgTypeLock', 'isBillCodeLock', 'isDescLock', 'isEntityLock', 'isCur1Lock', 'isRateQtyLock', 'isAgentLock', 'isCur2Lock', 'isAgentAmtLock', 'isPsLock', 'isVatLock', 'isSelectLock','billingCodeName', 'billingCodeView', 'isDescOnly');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return OpAcct.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_OPACCT' }),
        'chgType': new DBMappingInfo({ field: 'F_ChgType', table: 'T_OPACCT' }),
        'billingCode': new DBMappingInfo({ field: 'F_BillingCode', table: 'T_OPACCT' }),
        'description': new DBMappingInfo({ field: 'F_Description', table: 'T_OPACCT' }),
        'cur1': new DBMappingInfo({ field: 'F_Cur1', table: 'T_OPACCT' }),
        'rate': new DBMappingInfo({ field: 'F_Rate', table: 'T_OPACCT' }),
        'qty': new DBMappingInfo({ field: 'F_Qty', table: 'T_OPACCT' }),
        'actualAmt': new DBMappingInfo({ field: 'F_ActualAmt', table: 'T_OPACCT' }),
        'useVat': new DBMappingInfo({ field: 'F_UseVat', table: 'T_OPACCT' }),
        'vatAmount': new DBMappingInfo({ field: 'F_VATAmount', table: 'T_OPACCT' }),
        'lActAmt': new DBMappingInfo({ field: 'F_LActAmt', table: 'T_OPACCT' }),
        'actExrate': new DBMappingInfo({ field: 'F_ActExrate', table: 'T_OPACCT' }),
        'cur2': new DBMappingInfo({ field: 'F_Cur2', table: 'T_OPACCT' }),
        'agentAmt': new DBMappingInfo({ field: 'F_AgentAmt', table: 'T_OPACCT' }),
        'lAgtAmt': new DBMappingInfo({ field: 'F_LAgtAmt', table: 'T_OPACCT' }),
        'agtExrate': new DBMappingInfo({ field: 'F_AgtExRate', table: 'T_OPACCT' }),
        'agent': new DBMappingInfo({ field: 'F_Agent', table: 'T_OPACCT' }),
        'posted': new DBMappingInfo({ field: 'F_Posted', table: 'T_OPACCT' }),
        'entity': new DBMappingInfo({ field: 'F_Entity', table: 'T_OPACCT' }),
        'ps': new DBMappingInfo({ field: 'F_Ps', table: 'T_OPACCT' }),
        'iDate': new DBMappingInfo({ field: 'F_iDate', table: 'T_OPACCT' }),
        'loc': new DBMappingInfo({ field: 'f_loc', table: 'T_OPACCT' }),
        'tbName': new DBMappingInfo({ field: 'f_tbname', table: 'T_OPACCT' }),
        'tbId': new DBMappingInfo({ field: 'f_tbid', table: 'T_OPACCT' }),
        'invoiced': new DBMappingInfo({ field: 'F_Invoiced', table: 'T_OPACCT' }),
        'cloudOnly': new DBMappingInfo({ field: 'F_CloudOnly', table: 'T_OPACCT' }),
    };

    private static ExportCollection: XCol.XExportColumn[] = [ //for list sorting when header click
        XCol.Create({ col: 0, text: '', width: 10, dataIndex: 'locDesc', }),
        XCol.Create({ col: 1, text: '', width: 10, dataIndex: 'crDbNo' }),
        XCol.Create({ col: 2, text: '', width: 10, dataIndex: 'chgTypeDesc' }),
        XCol.Create({ col: 3, text: '', width: 10, dataIndex: 'billingCodeView', }),
        XCol.Create({ col: 4, text: '', width: 10, dataIndex: 'description' }),
        XCol.Create({ col: 5, text: '', width: 10, dataIndex: 'entityName' }),
        XCol.Create({ col: 6, text: '', width: 10, dataIndex: 'cur1', }),
        XCol.Create({ col: 7, text: '', width: 10, dataIndex: 'rate', type: XCol.XCellType.Double }),
        XCol.Create({ col: 8, text: '', width: 10, dataIndex: 'qty', type: XCol.XCellType.Double }),
        XCol.Create({ col: 9, text: '', width: 10, dataIndex: 'actualAmt', type: XCol.XCellType.Double  }),
        XCol.Create({ col: 10, text: '', width: 10, dataIndex: 'agentName' }),
        XCol.Create({ col: 11, text: '', width: 10, dataIndex: 'cur2' }),
        XCol.Create({ col: 12, text: '', width: 10, dataIndex: 'agentAmt', type: XCol.XCellType.Double }),
        XCol.Create({ col: 13, text: '', width: 10, dataIndex: 'ps', type: XCol.XCellType.Bool }),
        XCol.Create({ col: 14, text: '', width: 10, dataIndex: 'useVat', type: XCol.XCellType.Bool }),
        XCol.Create({ col: 15, text: '', width: 10, dataIndex: 'selected', type: XCol.XCellType.Bool }),
        XCol.Create({ col: 16, text: '', width: 10, dataIndex: 'invoiced', type: XCol.XCellType.Bool }),
        XCol.Create({ col: 17, text: '', width: 10, dataIndex: 'invoiceDate', type: XCol.XCellType.Date }),
        XCol.Create({ col: 18, text: '', width: 10, dataIndex: 'isDraft', type: XCol.XCellType.Bool }),
        XCol.Create({ col: 19, text: '', width: 10, dataIndex: 'invoiceNo' }),
        XCol.Create({ col: 20, text: '', width: 10, dataIndex: 'crDbNo' }),
        
    ];

    public static getExportCollection(): XCol.XExportColumn[] { //for list sorting when header click
        return this.ExportCollection;
    };

    static GetSQLInfoByInvoOrBillDetail(detailSqlInfo:SQLInfo, detail:InvoDetail|ApDetail, tbName:string, tbId:number, invoiceToId:number, invoiceDate:string|null, isVoid: boolean = false): SQLInfo {
        const isBill = detail instanceof ApDetail;
        let opAcctId = 0;
        
        if(!isBill) {
            opAcctId = isVoid ? 0 : detail.stbId;
        } else {
            if(detailSqlInfo.type === SQLType.Insert) {
                opAcctId = detail.id;
            } else if(detailSqlInfo.type === SQLType.Update) {
                opAcctId = detail.stbId;
            } else if(detailSqlInfo.type === SQLType.Delete) {
                opAcctId = detailSqlInfo.key?.value;
            }
        }

        const opAcctSqlInfo = new SQLInfo({
            tableName: 'T_OPACCT',
            key: new SQLField({ fieldName: 'F_Id', propertyName: 'OpAcct_Id', value: opAcctId}),
            type: detailSqlInfo.type === SQLType.Delete ? SQLType.Delete : (opAcctId > 0 ? SQLType.Update : SQLType.Insert)
        });

        if(detailSqlInfo.type === SQLType.Delete) {
            return opAcctSqlInfo;
        }

        if(detailSqlInfo.type === SQLType.Insert) {
            opAcctSqlInfo.fields.push(new SQLField({ fieldName: 'F_TBName', propertyName: 'OpAcct_TbName', value: tbName === 'T_WRECEIVEHD' ? 'T_WRECEIVE' : tbName}));
            opAcctSqlInfo.fields.push(new SQLField({ fieldName: 'F_TBId', propertyName: 'OpAcct_TbId', value: tbId}));
            switch(tbName) {
                case "T_OIMMAIN":
                case "T_OIHMAIN":
                case "T_AIMMAIN":
                case "T_AIHMAIN":
                case "T_GENMAIN":
                case "T_WRECEIVE":
                case "T_WRECEIVEHD":
                case "T_WSHIPHD":
                    opAcctSqlInfo.fields.push(new SQLField({ fieldName: "F_Loc", propertyName: "OpAcct_Loc", value: 2}));
                    break;

                case "T_OOMMAIN":
                case "T_OOHMAIN":
                case "T_AOHMAIN":
                case "T_AOMMAIN":
                    opAcctSqlInfo.fields.push(new SQLField({ fieldName: "F_Loc", propertyName: "OpAcct_Loc", value: 1}));
                    break;

            }
        }

        detailSqlInfo.fields.forEach(f => {

            const propsName = f.propertyName.lastIndexOf(".") >= 0 ? f.propertyName.slice(f.propertyName.lastIndexOf(".") + 1) : f.propertyName;
            switch(propsName) {
                case 'chgType':
                    let chgType = f.value === null || f.value === undefined ? 0 : parseInt(f.value);
                    if([2, 4, 12, 14].indexOf(chgType) >= 0 && detail.lAmount !== detail.lAgtAmount) {
                        chgType = isBill ? 13 : 3;
                    }
                    //else {
                    else if([3, 13].indexOf(chgType) >= 0 && detail.lAmount === detail.lAgtAmount && detail.lAgtAmount !== 0) {
                        chgType = isBill ? 14 : 4;
                    }
                    opAcctSqlInfo.fields.push(new SQLField({fieldName: 'F_ChgType', propertyName: 'OpAcct_ChgType', value: chgType}));
                    break;
                case 'billingCode':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_BillingCode", propertyName:"OpAcct_BillingCode", value: f.value}));
                    break;
                case 'description':
                    opAcctSqlInfo.fields.push(new SQLField({ fieldName: "F_Description", propertyName: "OpAcct_Description", value: f.value}));
                    break;
                case 'cur':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_Cur1", propertyName:"OpAcct_Cur1", value: f.value}));
                    break;
                case 'rate':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName: "F_Rate", propertyName: "OpAcct_Rate", value: f.value}));
                    break;
                case 'qty':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName: "F_Qty", propertyName: "OpAcct_Qty", value: f.value}));
                    break;
                case 'curAmount':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName: "F_ActualAmt", propertyName: "OpAcct_ActualAmt", value: f.value}));
                    break;
                case 'useVat':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName: "F_UseVat", propertyName: "OpAcct_UseVat", value: f.value}));                    
                    break;
                case 'vatAmount':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_VATAmount", propertyName:"OpAcct_VATAmount", value:f.value}));
                    break;
                case 'lAmount':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_LActAmt", propertyName:"OpAcct_LActAmt", value:f.value}));                    
                    break;
                case 'exRate':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_ActExrate", propertyName:"OpAcct_ActExrate", value:f.value}));
                    break;
                case 'agtCur':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_Cur2", propertyName:"OpAcct_Cur2", value: f.value}));
                    break;
                case 'agtAmount':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_AgentAmt", propertyName:"OpAcct_AgentAmt", value:f.value}));
                    break;
                case 'lAgtAmount':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_LAgtAmt", propertyName:"OpAcct_LAgtAmt", value:f.value}));
                    break; 
                case 'agtExRate':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_AgtExRate", propertyName:"OpAcct_AgtExRate", value:f.value}));
                    break;
                case 'agentId': // Invoice
                case 'agent':   // Bill
                    opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_Agent", propertyName:"OpAcct_Agent", value: f.value}));
                    break; 
                case 'entity':  // Bill
                    opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_Entity", propertyName:"OpAcct_Entity", value: invoiceToId}));
                    break;
                case 'ps':
                    opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_Ps", propertyName:"OpAcct_Ps", value:f.value}));
                    break;
            }
        });

        const posted = detail.posted ?? 0;
        if ((!isBill && posted < 3) || (isBill && posted < 4)) {
            opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_Posted", propertyName:"OpAcct_Posted", value:"2"}));
        }
        else if (posted === 3) {
            opAcctSqlInfo.fields.push(new SQLField({fieldName: "F_Posted", propertyName:"OpAcct_Posted", value:"4"}));
        }
        else {
            opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_Posted", propertyName:"OpAcct_Posted", value: posted.toString()}));
        }

        if(!isBill) {
            opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_Entity", propertyName:"OpAcct_Entity", value: invoiceToId}));
        }
        opAcctSqlInfo.fields.push(new SQLField({fieldName:"F_iDate", propertyName:"OpAcct_iDate", value:invoiceDate}));

        return opAcctSqlInfo;
    }
}

export function getLocFromJobName(jobName: JobNames) {
    if([JobNames.OIMbl, JobNames.OIHbl, JobNames.AIMbl, JobNames.AIHbl, JobNames.OtherOP, JobNames.WHRcv, JobNames.WHShip].indexOf(jobName) >= 0) {
        return 2;   // Dest
    } else {
        return 1;   // Origin
    }
}
